import Helpers from "./helpers";

export default class ShowMoreText {

	private wrapper: HTMLElement;
	private linkElement: HTMLElement;
	private isExpanded = false;

	constructor(wrapper) {

		this.wrapper = wrapper;
		this.linkElement = this.wrapper.querySelector('.js-text-toggle') as HTMLElement; 

		if (this.wrapper.getAttribute('data-reveal-mobile-only') === 'True' && this.isDesktopLayout()) {
			this.wrapper.classList.add('js-show-more-text-done');
			this.wrapper.classList.remove('is-closed');
			if (this.linkElement) {
				Helpers.removeElement(this.linkElement);
			}

			return;
		}
		this.init();
	}

	private init() {
		this.attachLinkClickEvent();
		this.wrapper.setAttribute('data-test', 'reveal-content-text');
		this.wrapper.classList.add('js-show-more-text-done');
	}

	private attachLinkClickEvent() {
		this.linkElement.addEventListener('click', (e) => {
			if (this.isExpanded) {
				this.linkElement.textContent = 'Show more';
				this.linkElement.setAttribute('aria-expanded', 'false');
				this.wrapper.classList.add('is-closed');
			}
			else {
				this.linkElement.textContent = 'Show less';
				this.linkElement.setAttribute('aria-expanded', 'true');
				this.wrapper.classList.remove('is-closed');
			}
			this.linkElement.setAttribute('data-test', 'reveal-button');
			this.isExpanded = !this.isExpanded;
			e.preventDefault();
		});
	}

	private isDesktopLayout() {
		return matchMedia('(min-width: 980px)').matches;
	}

}


